<template>
  <div>
    <c3-chart :height="350" :data="chartData" :config="chartConfig" type='line' />
    <div class="text-center text-muted">
      <template slot-scope="scope">
        {{ $t('reports_ui.fleet_health_report.violation_statistic_trends')}}
      </template>
    </div>
  </div>
</template>

<script>
import C3Chart from '@/components/shared/chart/C3Chart.vue'
import { filter, map, isEmpty, get, round } from 'lodash'

export default {
  name: 'ViolationStatisticTrends',
  components: {
    C3Chart
  },
  props: {
    customerReport: {
      type: Object
    }
  },
  computed: {
    /**
     * Get entries for all dates with data, filtering out those that don't.
     */
    filteredEntries () {
      return filter(this.customerReport.route_assessment_metrics, x => !isEmpty(x))
    },
    /**
     * Format the chart data needed for the graph.
     * @returns Object
     */
    chartData () {
      const dateColumn = this.getMappedData('date')
      dateColumn.unshift('date')

      const outstandingColumn = this.getMappedData('outstanding')
      outstandingColumn.unshift(this.$t('reports_ui.route_assessment_metrics_report.outstanding_violations'))

      const ageAvgColumn = this.getMappedData('age_avg')
      ageAvgColumn.unshift(this.$t('reports_ui.route_assessment_metrics_report.average_violation_age'))

      const ageMaxColumn = this.getMappedData('age_max')
      ageMaxColumn.unshift(this.$t('reports_ui.route_assessment_metrics_report.max_violation_age'))

      const assessedLateColumn = this.getMappedData('assessed_late')
      assessedLateColumn.unshift(this.$t('reports_ui.route_assessment_metrics_report.violations_assessed_late'))

      return {
        x: 'date',
        columns: [
          dateColumn,
          outstandingColumn,
          ageAvgColumn,
          ageMaxColumn,
          assessedLateColumn
        ]
      }
    },
    /**
     * The chart config.
     */
    chartConfig () {
      return {
        axis: {
          x: {
            label: {
              text: 'Date'
            },
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d',
              centered: true
            }
          },
          y: {
            label: {
              text: this.$t('number_of_violations')
            },
            tick: {
              format: function (d) {
                return round(d, 1)
              },
              culling: true
            }
          }
        },
        line: {
          connectNull: true
        }
      }
    }
  },
  methods: {
    /**
     * Convenience method to get data from the insights_dashboard_history field.
     * @param field
     * @returns {*}
     */
    getMappedData (field) {
      return map(this.customerReport.route_assessment_metrics, x => get(x, field, null))
    }
  }
}
</script>

<style scoped>

</style>
